import React from "react";
import { PeekButton, PeekSkeleton, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
export const PageHeaderTopTitle = ({ topTitle }) => {
    return (React.createElement(PeekButton, { onClick: topTitle.onClick, sx: { width: "fit-content", marginLeft: -1, opacity: 0.7 } },
        React.createElement(PeekStack, { direction: "row", alignItems: "center", gap: 0.5 },
            React.createElement(PeekTypography, { variant: "h3", lineHeight: "10px" }, topTitle.icon),
            topTitle.labelSkeleton ? (React.createElement(PeekSkeleton, { variant: "text", width: 160, sx: { fontSize: "h3.fontSize" } })) : (React.createElement(PeekTypography, { variant: "h3", textTransform: "uppercase" }, topTitle.label)))));
};
export default PageHeaderTopTitle;
